module.exports = __webpack_public_path__ + "img/linkend.8ccb11a0.png";